import { Skeleton } from '@material-ui/lab';
import {
  ColorDynamic,
  Column,
  Columns,
  Inline,
  Stack,
} from '@superdispatch/ui';
import { forwardRef } from 'react';

import styled from 'styled-components';

function LoadOptionSkeletonItem() {
  return (
    <SkeletonItem>
      <Stack space="xsmall">
        <Columns>
          <Column width="fluid">
            <Columns space="xxsmall" align="center">
              <Column width="content">
                <Skeleton variant="text" width={52} height={16} />
              </Column>
              <Column width="adaptive">
                <Skeleton variant="text" width={80} height={16} />
              </Column>
            </Columns>
          </Column>
          <Column width="content">
            <Inline space="xsmall">
              <Skeleton variant="rect" width={48} height={20} />
              <Skeleton variant="rect" width={56} height={20} />
            </Inline>
          </Column>
        </Columns>

        <Skeleton variant="text" width={72} height={16} />

        <Columns space="xxsmall">
          <Column width="content">
            <SkeletonGutter>
              <Skeleton variant="circle" width={8} height={8} />
              <SkeletonGutterLine />
              <Skeleton variant="rect" width={8} height={8} />
            </SkeletonGutter>
          </Column>
          <Column width="fluid">
            <Stack space="xxsmall">
              <Skeleton variant="text" width="70%" height={14} />
              <Skeleton variant="text" width="60%" height={14} />
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </SkeletonItem>
  );
}

const SkeletonItem = styled.li`
  padding: 8px 16px;
`;

const SkeletonGutter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 2px 0;
`;

const SkeletonGutterLine = styled.div`
  width: 2px;
  height: 12px;
  background: repeating-linear-gradient(
    ${ColorDynamic.Dark100},
    ${ColorDynamic.Dark100} 3px,
    transparent 3px,
    transparent 5px
  );
`;

export const LoadOptionList = forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(function LoadOptionListbox({ children, ...props }, ref) {
  const isBusy = props['aria-busy'];

  return (
    <ul {...props} ref={ref}>
      {children}
      {isBusy && <LoadOptionSkeletonItem />}
    </ul>
  );
});
